import Box from "@mui/material/Box"
import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { uomLoader } from "@/screens/WarehouseReceiving/loaders"
import { SoftReceivedGoodsReceiptDetailsLayout } from "@/screens/WarehouseReceiving/subfeatures/SoftReceived/components"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => (
    <Box className='flex size-full flex-col'>
      <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSE_RECEIVING_VIEW]}>
        <SoftReceivedGoodsReceiptDetailsLayout />
      </PermissionContentWrapper>
    </Box>
  ),
})
